import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'Redirect',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect1',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('login.login'),
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  },
  {
    path: '/403',
    component: () => import('@/views/Error/403.vue'),
    name: 'Forbidden',
    meta: {
      hidden: true,
      title: '403',
      noTagsView: true
    }
  },
  {
    path: '/test',
    component: () => import('@/views/test/index.vue'),
    name: 'Test',
    meta: {
      hidden: true,
      title: 'test',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/area',
    component: Layout,
    redirect: '/area/setting',
    name: 'AreaMonitor',
    meta: {
      title: 'menu.title',
      icon: 'bx:bxs-component',
      alwaysShow: true
    },
    children: [
      {
        path: 'setting',
        component: () => import('@/views/Area/Setting/index.vue'),
        name: 'AreaSetting',
        meta: {
          title: 'menu.areaSetting',
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        },
        children:[
          {
            path: 'edit',
            component: () => import('@/views/Area/Setting/Edit.vue'),
            name: 'AreaSettingEdit',
            meta: {
              title: 'menu.areaSetting',
              noCache: true,
              affix: true,
              hidden:true,
              hideBreadcrumb:true,
              activeMenu: '/area/setting',
              activeMenuName:'AreaSetting'              
            },
          }
        ]
      },
      {
        path: 'monitor',
        component: () => import('@/views/Area/Monitor/index.vue'),
        name: 'PositionMonitor',
        meta: {
          title: 'menu.areaMonitor',
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
      {
        path: 'display',
        component: () => import('@/views/Area/Monitor/Display.vue'),
        name: 'PositionDisplay',
        meta: {
          title: 'display',
          noCache: true,
          affix: true,
          hidden:true,
          hideBreadcrumb:false
        }
      }
    ]    
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  const resetWhiteNameList = ['Redirect', 'Login', 'NoFind', 'Root']
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
